import { WorkspaceContext } from '@context/WorkspaceContext';
import { useContext } from 'react';

const useWorkspace = () => {
  return useContext(WorkspaceContext);
};

export default useWorkspace;
